module.exports = __webpack_public_path__ + "static/img/65.ad11583.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/img_right_icon/65.png
// module id = TUJn
// module chunks = 1